import i18n, { InitOptions, Module } from "i18next";
import { initReactI18next } from "react-i18next";

const LAST_MODIFIED_PREFIX = "lastModified_";

type FetchTranslationParam = {
  loadPath: string;
  lastModified: string;
  language: string;
};

async function fetchTranslations(options: FetchTranslationParam) {
  const { loadPath, lastModified } = options;

  const headResponse = await fetch(loadPath, {
    method: "HEAD",
    headers: {
      "If-Modified-Since": lastModified || "",
    },
  });

  if (headResponse.status === 200) {
    const newLastModified = headResponse.headers.get("Last-Modified");

    if (newLastModified !== lastModified) {
      const getResponse = await fetch(loadPath);
      const translations = await getResponse.json();
      return { translations, lastModified: newLastModified };
    }
  }

  return { translations: null, lastModified };
}

class CustomBackend {
  private options: { loadPath: string };
  public type: string;

  constructor() {
    this.type = "backend";
    this.options = { loadPath: "" };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(_services: any, options: InitOptions, _i18nextOptions: any) {
    this.type = "backend";
    this.options = { ...this.options, ...options };
  }

  read(language: string, namespace: string, callback: (error: any, data: any) => void) {
    let { loadPath } = this.options;

    loadPath = loadPath.replace("{{lng}}", language).replace("{{ns}}", namespace);

    let cacheTranslation = {} as { [k: string]: any };
    if (localStorage.getItem(`${LAST_MODIFIED_PREFIX}${language}`)) {
      cacheTranslation = JSON.parse(
        localStorage.getItem(`${LAST_MODIFIED_PREFIX}${language}`) || ""
      ) as { [k: string]: any };
    }

    if (!loadPath) {
      return callback(null, cacheTranslation.translations || null);
    }

    fetchTranslations({
      loadPath,
      lastModified: cacheTranslation?.lastModified || "",
      language,
    })
      .then(result => {
        if (result.translations) {
          localStorage.setItem(
            `${LAST_MODIFIED_PREFIX}${language}`,
            JSON.stringify(result)
          );
          callback(null, result.translations);
        } else {
          callback(null, cacheTranslation.translations || null);
        }
      })
      .catch(error => {
        callback(error, null);
      });
  }
}

let backend = new CustomBackend();

i18n
  .use(backend as Module)
  .use(initReactI18next)
  .init({
    fallbackLng: ["en"],
    preload: ["en"],
    detection: {
      order: ["navigator"],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
